/** Auto-generated Excel column/header enums for golf exports. */

export enum GolfExcelHeader {
  NumberOfMinutes = "# of Minutes",
  AddressLine1 = "AddressLine1",
  AddressLine2 = "AddressLine2",
  AddressLine3 = "AddressLine3",
  AllocationBlockCode = "AllocationBlockCode",
  AllocationBlockName = "AllocationBlockName",
  AllowTaxOnGratuity = "AllowTaxOnGratuity",
  AllowTaxOnServiceCharge = "AllowTaxOnServiceCharge",
  AutoReceipt = "AutoReceipt",
  AvailableDaysOfWeek = "Available Days of Week",
  AvailableDaysOfWeek2 = "AvailableDaysOfWeek",
  AvailableDaysOfTheWeek = "Available Days of the Week",
  AvgPlay18Holes = "AvgPlay18Holes",
  AvgPlay9Holes = "AvgPlay9Holes",
  CancelReason = "CancelReason",
  CartFeeAmountDollars = "Cart Fee Amount($)",
  CartFeeItemNumber = "Cart Fee Item #",
  Category = "Category",
  CategoryGroupName = "CategoryGroupName",
  City = "City",
  Closed = "Closed",
  ClosedQ = "Closed ?",
  ColorCode = "ColorCode",
  Comments = "Comments",
  ContactType = "ContactType",
  Country = "Country",
  Course = "Course",
  CourseName = "CourseName",
  DaysOut = "DaysOut",
  DaysOutEnd = "DaysOutEnd",
  DaysOutStart = "DaysOutStart",
  DiscountReason = "DiscountReason",
  DiscountType = "DiscountType",
  DisplayOnTeesheet = "DisplayOnTeesheet",
  EligibleForDiscount = "EligibleForDiscount",
  EligibleForCostOrCostPlus = "EligibleForCostOrCostPlus",
  EligibleForInHouseServiceChargeCalculation = "EligibleForInHouseServiceChargeCalculation",
  EndDate = "End Date",
  EndTime = "End Time",
  EndDate2 = "EndDate",
  EntryFee = "EntryFee",
  EntryFeeRetailItem = "EntryFeeRetailItem",
  GreenFee = "GreenFee",
  GreenFeeAmountDollars = "Green Fee Amount($)",
  GreenFeeItemNumber = "Green Fee Item #",
  GreenFeeRetailItem = "GreenFeeRetailItem",
  CartFee = "CartFee",
  CartFeeRetailItem = "CartFeeRetailItem",
  Courses = "Courses",
  GuaranteeType = "GuaranteeType",
  Id = "Id",
  IntervalMinutes = "Interval Minutes",
  IsActive = "IsActive",
  IsAmountOrPercentage = "IsAmountOrPercentage",
  IsAvailableOnWeb = "IsAvailableOnWeb",
  IsDefault = "IsDefault",
  IsDefaultTax = "IsDefaultTax",
  HasTaxOnTax = "HasTaxOnTax",
  AllowRemovalForPaymentMethod = "AllowRemovalForPaymentMethod",
  ExcludeForTaxExemption = "ExcludeForTaxExemption",
  IsNineHoles = "IsNineHoles",
  IsPrimary = "IsPrimary",
  IsPrivateInfo = "IsPrivateInfo",
  IsSupressReceipt = "IsSupressReceipt",
  Level = "Level",
  Location = "Location",
  MinimumPlayers = "MinimumPlayers",
  Name = "Name",
  OutletName = "OutletName",
  Outlets = "Outlets",
  PlayerType = "PlayerType",
  PlayerTypes = "PlayerTypes",
  PostalCode = "PostalCode",
  ProfitCenter = "ProfitCenter",
  RateType = "Rate Type",
  RateType2 = "RateType",
  RateTypes = "RateTypes",
  RepresentativeFname = "RepresentativeFname",
  RepresentativeLname = "RepresentativeLname",
  ResvRqd = "ResvRqd",
  ShowOnTeeSheet = "Show on Tee Sheet",
  StartDate = "Start Date",
  StartTime = "Start Time",
  StartDate2 = "StartDate",
  State = "State",
  SwitchTime = "SwitchTime",
  SwitchToAllocationBlockName = "SwitchToAllocationBlockName",
  TaxAmount = "TaxAmount",
  TaxName = "TaxName",
  TaxValue = "TaxValue",
  TemplateCode = "Template Code",
  TemplateName = "Template Name",
  TerminalId = "TerminalId",
  Terms = "Terms",
  Time = "Time",
  Type = "Type",
  Value = "Value",
  VendorCode = "VendorCode",
  VendorName = "VendorName",
  VendorType = "VendorType",
}

export enum GolfExcelSourceField {
  NumberOfMinutes = "# of Minutes",
  N9Hole = "9 Hole",
  Active = "Active",
  Address = "Address",
  AllocationBlockCode = "Allocation Block Code",
  AllocationBlockName = "Allocation Block Name",
  AllowTaxOnGratuity = "Allow Tax on Gratuity",
  AllowTaxOnServiceCharge = "Allow Tax on Service Charge",
  AllowRemovalForPaymentMethod = "Allow Removal for Payment Method",
  ChargeTaxOnTax = "Charge Tax on Tax",
  ExcludeForTaxExemption = "Exclude for Tax Exemption",
  AutoPrintsReceipts = "Auto Prints Receipts",
  AvailableDaysOfWeek = "Available Days of Week",
  AvailableDaysOfWeek2 = "AvailableDaysOfWeek",
  AvailableDaysOfTheWeek = "Available Days of the Week",
  AvailableOnWeb = "Available on Web",
  CancelReasons = "Cancel Reasons",
  CartFee = "CartFee",
  CartFeeAmountDollars = "Cart Fee Amount($)",
  CartFeeItemNumber = "Cart Fee Item #",
  CartFeeRetailItem = "CartFeeRetailItem",
  CategoryGroup = "Category Group",
  CategoryName = "Category Name",
  City = "City",
  ClosedQ = "Closed ?",
  ColorOptions = "Color Options",
  Comments = "Comments",
  ContactType = "Contact Type",
  Country = "Country",
  Course = "Course",
  Courses = "Courses",
  CourseName = "Course Name",
  EntryFee = "EntryFee",
  EntryFeeRetailItem = "EntryFeeRetailItem",
  GreenFee = "GreenFee",
  GreenFeeRetailItem = "GreenFeeRetailItem",
  DaysOutStart = "Days Out Start",
  DaysOut = "Days out",
  DaysOutEnd = "Days out End",
  DaysOutStart2 = "Days out Start",
  Default = "Default",
  DefaultOutlet = "Default Outlet",
  DefaultToAllRetailItems = "Default to all Retail Items",
  DiscountReason = "Discount Reason",
  DiscountType = "Discount Type",
  DurationOfPlay18Holes = "Duration of Play 18 Holes",
  DurationOfPlay9Holes = "Duration of Play 9 Holes",
  EligibleForDiscount = "Eligible for Discount",
  EligibleForCostOrCostPlus = "Eligible for Cost Plus",
  EligibleForInHouseServiceChargeCalculation = "Eligible for In House Service Charge",
  EndDate = "End Date",
  EndTime = "End Time",
  FirstName = "First Name",
  GreenFeeAmountDollars = "Green Fee Amount($)",
  GreenFeeItemNumber = "Green Fee Item #",
  Guarantee = "Guarantee",
  IntervalMinutes = "Interval Minutes",
  IsPrimary = "Is Primary",
  IsPrivateInfo = "Is Private Info",
  LastName = "Last Name",
  LessonLocations = "Lesson Locations",
  MinNumberPlayers = "Min # Players",
  Outlet = "Outlet",
  OutletName = "Outlet Name",
  PercentageOrFlatAmount = "Percentage or Flat Amount",
  PlayerType = "Player Type",
  PostalCode = "Postal Code",
  QuickSaleCategory = "Quick Sale Category",
  RateType = "Rate Type",
  RateType2 = "RateType",
  ShowOnTeeSheet = "Show on Tee Sheet",
  StartDate = "Start Date",
  StartDate2 = "StartDate",
  StartTime = "Start Time",
  EndDate2 = "EndDate",
  State = "State",
  SubCategoryName = "Sub Category Name",
  SubCategoryNumber = "Sub Category Number",
  SuppressOnReceipt = "Suppress on Receipt",
  SwitchTo = "Switch To",
  TaxName = "Tax Name",
  TemplateCode = "Template Code",
  TemplateName = "Template Name",
  Time = "Time",
  Value = "Value",
  VendorCode = "Vendor Code",
  VendorName = "Vendor Name",
  VendorType = "Vendor Type",
}

export enum GolfExcelSheetName {
  AllocationBlock = "AllocationBlock",
  CancellationReasons = "CancellationReasons",
  Category = "Category",
  CategoryGroup = "CategoryGroup",
  Course = "Course",
  DiscountReasons = "DiscountReasons",
  DiscountTypes = "DiscountTypes",
  LessonLocation = "LessonLocation",
  Outlet = "Outlet",
  PlayerType = "PlayerType",
  PlayerTypeMapping = "PlayerTypeMapping",
  QuickSaleCategory = "QuickSaleCategory",
  RateType = "RateType",
  RateTypeMapping = "RateTypeMapping",
  RatesSetup = "Rates Setup",
  RatePlan = "RatePlan",
  RetailItem = "RetailItem",
  SubCategory = "SubCategory",
  Tax = "Tax",
  TeeTimeIntervalSetup = "Tee Time Interval Setup",
  TeeTimeIntervalTemplates = "Tee Time Interval Templates",
  Vendor = "Vendor",
  VendorContactInformation = "VendorContactInformation",
  VendorType = "VendorType",
}
